import React, { PropTypes, Component } from 'react'
import { withRouter } from 'react-router-dom'
import style from './style.css'


class MissSunrise extends Component {

  render() {
    return (
      <div className={ style.container } onClick={ () => { window.location = 'http://www.missintercontinental.com/voting-miss-intercontinental-2017/' } }>
        <div className={ style.banner }></div>
        <div className={ style.text }>
          <h3>MISS SUNRISE RESORTS 2017</h3>
          <p>
          This is the official Voting for the MISS SUNRISE RESORTS 2017 starting January 12th! We will consider this Voting as Popularity Award and the Winner of this Voting, will be automatically find a Spot additionally in the Finale as Finalist so that this year we will announce the TOP 6 in the Final Round. The Vote will Stop on 23rd at 9pm (Egyptian Time).
          </p>
        </div>
      </div>
    )
  }
}

export default withRouter(MissSunrise)



// WEBPACK FOOTER //
// ./src/components/homescreen/misssunrise/index.js